import cls from "@fvilers/cls";
import { ComponentProps, use } from "react";
import { TabsContext } from "./context/TabsContext";
import styles from "./TabPanel.module.css";

export type TabPanelProps = {
  className?: string;
  value: string;
} & Omit<ComponentProps<"section">, "role">;

export function TabPanel({ className, value, ...props }: TabPanelProps) {
  const { activeTab, unmount } = use(TabsContext);

  if (activeTab !== value && unmount) {
    return null;
  }

  return (
    <section
      aria-labelledby={`${value}-tab`}
      className={cls(styles.TabPanel, className)}
      data-active={activeTab === value ? "true" : "false"}
      hidden={activeTab !== value}
      id={`${value}-panel`}
      role="tabpanel"
      {...props}
    />
  );
}
